import {HttpUrlEncodingCodec} from '@angular/common/http';

export class CustomHttpUrlEncodingCodecUtil extends HttpUrlEncodingCodec {

    override encodeValue(value: string): string {
        value = super.encodeValue(value);
        return value.replace('+', '%2B');
    }
}
